import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import moment from 'moment';
import SearchForm from './SearchFormInvoice';

export default class Invoices extends Component {
    constructor(props) {
        super(props)
        this.state = {
            clients: [],
            errors: [],
            startDate: null,
            endDate: null
        }
        this.loadDataByRange = this.loadDataByRange.bind(this);
        this.handleDetailInvoice = this.handleDetailInvoice.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.fireRedirect = this.fireRedirect.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }
    
    /**
     * Get search data
     */
    handleSearch(key) {
        function isExistData(data) {
            return data == '';
        }
        if (Object.values(key).every(isExistData)) {
            var startDate = moment().startOf('month'), endDate = moment().endOf('month');
            this.loadDataByRange(startDate, endDate);
        } else {
            axios.post('/api/clients/invoices/search', key).then(response => {
                this.setState({
                    clients: response.data
                });
            });
        }
    }
    
    /**
     * Redirect to detail invoice
     */
    handleDetailInvoice(data){
        this.props.history.push('/clients/detail-invoice/' + data.id + '/' + this.state.startDate.format("YYYY-MM-DD") + '/' + this.state.endDate.format("YYYY-MM-DD"));
    }
    
    /**
     * Load data clients by date
     */
    loadDataByRange(startDate,endDate) {
        this.state.startDate = startDate;
        this.state.endDate = endDate;
        axios.get('/api/clients/invoices/' + this.state.startDate.format("YYYY-MM-DD") +'/' + this.state.endDate.format("YYYY-MM-DD")).then(response => {
            this.setState({
                clients: response.data
            });
        });
    }
    
    /**
     * Init data and form client or list clients
     */
    componentWillMount() {
        var startDate, endDate;
        if (this.props.match.params.hasOwnProperty('startDate') && this.props.match.params.hasOwnProperty('endDate')) {
            startDate = moment(this.props.match.params.startDate);
            endDate = moment(this.props.match.params.endDate);
        }else{
            startDate = moment().startOf('month');
            endDate = moment().endOf('month');
        }
        this.loadDataByRange(startDate,endDate);
    }

    handleRedirect(url) {
        this.setState({
            isShowForm: false
        })
        this.props.history.push(url);
    }
    
    fireRedirect(e) {
        e.preventDefault()
        this.handleRedirect(e.currentTarget.getAttribute('href'));
    }
    
    render() {
        const columns = [
            {name: 'id', title: 'ID', isSort: 1, type: 'text'},
            {name: 'client_no', title: 'No.', isSort: 1, type: 'text', isSearch:true},
            {name: 'first_last_name', title: '依頼者名', isSort: 0, type: 'text', isSearch:true},
            {name: 'email', title: '依頼者メール', isSort: 1, type: 'text'},
            {name: 'created_at', title: '登録日', isSort: 1, type: 'date'},
        ]
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.fireRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">請求一覧</li>
                            </ol>
                        </nav>
                    </div>
		</div>

		<main id="main">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h4 className="mt-2 mb-0 page-title">請求一覧</h4>
                                        </div>
                                        <div className="col text-right">
                                            <button className="btn btn-light" type="button" data-toggle="collapse" data-target="#search_invoices" aria-expanded="false" aria-controls="search_client">絞込検索</button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <SearchForm onSearch={this.handleSearch} />
                                        </div>
                                    </div>
                                </div>
                            <Table startDate={this.state.startDate} endDate={this.state.endDate} onSearch={this.handleSearch} loadDataByRange={this.loadDataByRange} onEdit={this.handleDetailInvoice} columnSearch="name" header={columns} data={this.state.clients} />
                            </div>
                        </div>
                    </div>
		</main>
            </React.Fragment>
        );
    }
}